import { createContext, useContext, type ReactNode } from 'react';

export type LoginFlowVariant = 'sheet' | 'page';

/* eslint-disable react-refresh/only-export-components */

const LoginFlowVariantContext = createContext<LoginFlowVariant>('sheet');

export const useLoginFlowVariant = (): LoginFlowVariant => useContext(LoginFlowVariantContext);

export function LoginFlowVariantProvider({ variant, children }: { variant: LoginFlowVariant; children: ReactNode }) {
    return <LoginFlowVariantContext value={variant}>{children}</LoginFlowVariantContext>;
}
